import React from "react";
import style from "./Layout.module.scss";
import Header from "../Header";
import Footer from "../../../../components/Footer";

export default function Layout({ children }: { children: React.ReactNode }) {
    return (
        <div className={style.root}>
            <Header />

            <div className={style.container}>{children}</div>

            <Footer />
        </div>
    );
}
